export { Divider } from "@mantine/core";
export type { DividerProps } from "@mantine/core";
export { dividerOverrides } from "./Divider.config";
